<template>
  <GridRow>
    <GridCol cols="3" class="mt-2">
      <div
        ref="labelBox"
        v-tooltip.right="{
          value: label,
          disabled: !isTruncated,
        }"
        :class="align ? 'align-self-center' : 'align-items-start'"
        class="text-truncate text-right"
      >
        <slot name="label">{{ label }}</slot>
      </div>
    </GridCol>

    <GridCol cols="9">
      <slot>&nbsp;</slot>
    </GridCol>
  </GridRow>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from "vue";
import vTooltip from "primevue/tooltip";
import GridCol from "../shared/utility/GridCol.vue";
import GridRow from "../shared/utility/GridRow.vue";
defineProps({
  label: {
    type: String,
    default: "",
  },
  align: {
    type: Boolean,
    default: false,
  },
});
const labelBox = ref<HTMLElement | null>(null);
const isTruncated = ref(false);

let resizeObserver: ResizeObserver | null = null;

function checkOverflow() {
  if (!labelBox.value) return false;
  const el = labelBox.value;
  isTruncated.value = el.offsetWidth < el.scrollWidth;
}

onMounted(() => {
  if (labelBox.value == null) {
    return;
  }
  resizeObserver = new ResizeObserver(() => {
    checkOverflow();
  });
  resizeObserver.observe(labelBox.value as HTMLElement);
});

onBeforeUnmount(() => {
  resizeObserver?.disconnect();
});
</script>
